<div
  class="cmdk-wrapper"
  (click)="onBackdropClick($event)"
  data-bs-theme="dark"
>
  <div class="cmdk-backdrop"></div>

  <button
    type="button"
    class="btn-close btn-close-lg me-auto"
    aria-label="Cerrar"
    (click)="close.emit()"
    tabindex="-1"
  ></button>

  <div class="container mx-auto">
    <div class="card cmdk-card mx-auto">
      <div class="card-body">
        <p class="h4 text-center text-white mb-4 mb-lg-5">Búsqueda en Liber</p>

        <form
          class="d-flex align-items-center gap-2 mb-3"
          [formGroup]="form"
          (ngSubmit)="search()"
        >
          <input
            #searchInput
            type="search"
            placeholder="Escriba su busqueda..."
            formControlName="query"
            class="form-control"
            autocomplete="off"
          />

          <button
            type="submit"
            class="btn btn-primary"
            (click)="search()"
            [disabled]="form.invalid"
          >
            Buscar
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
